import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { styled } from '@mui/material/styles';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';
import esMx from 'dayjs/locale/es-mx';
import COLORS from '../styles/Colors';

const StyledTextField = styled(TextField)(({ theme, disabled }) => ({
  height: '100%',
  width: '100%',
  '& .MuiInputBase-root': {
    height: '100%',
    borderRadius: 0,
  },
  '& .MuiInputBase-input': {
    color: disabled ? COLORS.ZINC500 : COLORS.SLATE300,
    padding: theme.spacing(1, 0.5, 1, 0.75),
    fontSize: '0.85rem',
    width: '100%',
  },
  '& .MuiFormLabel-root': {
    color: disabled ? COLORS.ZINC500 : COLORS.GREEN500,
    fontSize: '0.85rem',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: `2px solid ${disabled ? COLORS.ZINC600 : COLORS.GREEN500} !important`,
    borderRadius: 0,
  },
  '& .Mui-focused': {
    '&.MuiFormLabel-root': { color: `${COLORS.CYAN500}` },
    '& .MuiOutlinedInput-notchedOutline': {
      border: `2px solid ${COLORS.CYAN500} !important`,
    },
  },
  '& svg': {
    color: disabled ? COLORS.ZINC600 : COLORS.SKY200,
    fontSize: '1.1rem',
  },
  '& .MuiInputAdornment-root': {
    marginLeft: 0,
  },
}));

const StyledWrapperFrom = styled('div')(() => ({
  height: '100%',
  width: '50%',
  '& .MuiOutlinedInput-notchedOutline': {
    borderRightWidth: '1px !important',
    borderRadius: '6px 0 0 6px !important',
  },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderRightWidth: '1px !important',
    borderRadius: '6px 0 0 6px !important',
  },
}));

const StyledWrapperTo = styled('div')(() => ({
  height: '100%',
  width: '50%',
  '& .MuiOutlinedInput-notchedOutline': {
    borderLeftWidth: '0px !important',
    borderRadius: '0 6px 6px 0 !important',
  },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderLeftWidth: '1px !important',
    borderRadius: '0 6px 6px 0 !important',
  },
}));

const StyledContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  width: '100%',
}));

const StyledPickersRow = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  height: '48px',
  '@media (max-width: 600px)': {
    flexWrap: 'wrap',
    height: 'auto',
  },
}));

const StyledSearchButton = styled('button')(() => ({
  padding: '0 1.5rem',
  backgroundColor: 'transparent',
  color: COLORS.GREEN500,
  border: `2px solid ${COLORS.GREEN500}`,
  borderRadius: '6px',
  cursor: 'pointer',
  fontSize: '1rem',
  whiteSpace: 'nowrap',
  transition: 'all 0.2s ease-in-out',
  height: '48px',
  margin: '0 0 0 0.5rem',
  width: 'auto',
  '@media (max-width: 600px)': {
    display: 'none',
  },
}));

const renderPickerInput = (params, isDisabled) => {
  const {
    InputProps,
    className,
    error,
    inputRef,
    ref,
    label,
    inputProps,
  } = params;
  return (
    <StyledTextField
      fullWidth
      disabled={isDisabled}
      InputProps={{
        ...InputProps,
        inputProps: {
          ...inputProps,
          style: { textTransform: 'capitalize' },
          readOnly: true,
        },
      }}
      variant="outlined"
      className={className}
      error={error}
      inputRef={inputRef}
      label={label}
      ref={ref}
    />
  );
};

const DateRangePicker = ({
  dateFrom,
  dateTo,
  handleDateFrom,
  handleDateTo,
  withSearchButton,
  onSearch,
}) => {
  const hasFrom = Boolean(dateFrom);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={esMx}>
      <StyledContainer>

        <StyledPickersRow>
          <StyledWrapperFrom>
            <DatePicker
              views={['year', 'month', 'day']}
              inputFormat="DD/MMMM/YYYY"
              label="Inicio"
              value={dateFrom}
              disableFuture
              disableMaskedInput
              onChange={handleDateFrom}
              renderInput={(params) => renderPickerInput(params, false)}
            />
          </StyledWrapperFrom>

          <StyledWrapperTo>
            <DatePicker
              views={['year', 'month', 'day']}
              inputFormat="DD/MMMM/YYYY"
              label={hasFrom ? 'Final' : 'Primero elige inicio'}
              value={hasFrom ? dateTo : null}
              disabled={!hasFrom}
              disableFuture
              disableMaskedInput
              minDate={hasFrom ? dayjs(dateFrom) : undefined}
              onChange={handleDateTo}
              renderInput={(params) => renderPickerInput(params, !hasFrom)}
            />
          </StyledWrapperTo>

          {withSearchButton && (
            <StyledSearchButton
              type="button"
              onClick={onSearch}
            >
              Mostrar
            </StyledSearchButton>
          )}
        </StyledPickersRow>

      </StyledContainer>
    </LocalizationProvider>
  );
};

export default DateRangePicker;
